<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>
<form nz-form class="hx-form" [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" *transloco="let tr; prefix: 'workflows'; scope: 'workflows'">
  <div nz-row [nzGutter]="8">
    <div nz-col class="hx-col-1">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('form.title')}}</nz-form-label>
        <nz-form-control>
          <hx-label-edit formControlName="title"></hx-label-edit>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row [nzGutter]="8">
    <div nz-col class="hx-col-2">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('form.description')}}</nz-form-label>
        <nz-form-control>
          <editor apiKey="1m5chqcqshgnbigriyg35bln3i932yz4xn4obqarh45v1dby" formControlName="description" [init]="{
              language_url:'/assets/i18n/tinymce/ru.js',
              language_load: true,
              language: 'ru',
              plugins: 'lists link image table code help wordcount'}">
          </editor>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row [nzGutter]="8">
    <div nz-col class="hx-col-2">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('form.order')}}</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="order"/>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row [nzGutter]="8">
    <div nz-col class="hx-col-2">
      <nz-form-item>
        <nz-form-label>{{tr('form.servicePrice')}}</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="servicePrice"/>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>


  <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

  <div nz-row [nzGutter]="8" class="cp_actions">
    <div nz-col>
      <nz-form-item>
        <nz-form-control>
          <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
            <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col>
      <nz-tag nzColor="success" *ngIf="form.pristine && model.id">
        <i nz-icon nzType="check-circle"></i>
        <span>{{'form.saved' | transloco}}</span>
      </nz-tag>
    </div>
  </div>
</form>
